import type { SupplierUploadTracking } from '../../../lib/api/barratt';
import { exportToCSV } from '../../../utils/chartExport';
import { datasetLabel, formatDay, formatDayTime } from '../uploadCycle';
import type { UploadTab } from './useUploadHistory';

type CsvRow = Record<string, unknown>;

/**
 * Downloads the current tab's rows as `supplier-uploads-<period>-<tab>.csv`.
 * Columns mirror the on-screen table so the export reads like the page.
 */
export function exportUploadHistoryCsv(tab: UploadTab, period: string, rows: SupplierUploadTracking[]): void {
  const filename = `supplier-uploads-${period}-${tab}`;

  if (tab === 'uploaded') {
    const data: CsvRow[] = rows.map((row) => ({
      supplier: row.supplier_name ?? '',
      dataset: datasetLabel(row),
      uploaded: formatDayTime(row.uploaded_at),
      file: row.file_name ?? '',
      records: row.records_count,
      otif_pct: row.otif_pct ?? '',
      ncrs: row.ncr_count ?? '',
    }));
    exportToCSV(data, filename, [
      { key: 'supplier', header: 'Supplier' },
      { key: 'dataset', header: 'Dataset' },
      { key: 'uploaded', header: 'Uploaded' },
      { key: 'file', header: 'File' },
      { key: 'records', header: 'Records' },
      { key: 'otif_pct', header: 'OTIF %' },
      { key: 'ncrs', header: 'NCRs' },
    ]);
    return;
  }

  const data: CsvRow[] = rows.map((row) => ({
    supplier: row.supplier_name ?? '',
    dataset: datasetLabel(row),
    contact_email: row.supplier_email ?? '',
    due: formatDay(row.due_date),
    status: row.status_display ?? row.status,
    last_reminder: row.last_reminder_at ? formatDayTime(row.last_reminder_at) : 'Never',
    reminders_sent: row.reminder_count,
  }));
  exportToCSV(data, filename, [
    { key: 'supplier', header: 'Supplier' },
    { key: 'dataset', header: 'Dataset' },
    { key: 'contact_email', header: 'Contact email' },
    { key: 'due', header: 'Due' },
    { key: 'status', header: 'Status' },
    { key: 'last_reminder', header: 'Last reminder' },
    { key: 'reminders_sent', header: 'Reminders sent' },
  ]);
}
